import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import App from './App.vue'

import PouchDB from 'pouchdb-browser';
import PouchDBAuthentication from 'pouchdb-authentication';

PouchDB.plugin(PouchDBAuthentication);

import './assets/sass/main.scss'

const FourOhFour = { template: '<div><h1>404</h1><a href="/">Home</a></div>' }

import AllRecipes from '@/components/AlldocsRecipeList.vue'
import CategoryPage from "@/components/FindRecipeList.vue"
import CategoryList from '@/components/CategoryList.vue'
import RecipePage from '@/components/RecipePage.vue'
import LoginPage from '@/components/LoginPage.vue'
import EditRecipe from '@/components/RecipeEditPage.vue'
import AddRecipe from '@/components/RecipeAddPage.vue'
import AdminPage from '@/components/AdminPage.vue'
import TagList from '@/components/TagList.vue'
import TagPage from '@/components/TagPage.vue'
import NewRecipesPage from '@/components/NewRecipesPage.vue'
import ImportRecipePage from '@/components/RecipeImportPage.vue'

const routes = [
  { path: '/', component: CategoryList },
  { path: '/login', component: LoginPage },
  { path: '/admin', component: AdminPage },
  { path: '/recipe/:id/edit', component: EditRecipe, props: true },
  { path: '/recipe/:id', component: RecipePage, props: true },
  { path: '/new', component: NewRecipesPage },
  { path: '/import', component: ImportRecipePage },
  { path: '/categories', component: CategoryList },
  { path: '/categories/all', component: AllRecipes },
  { path: '/categories/:cat', component: CategoryPage, props: true },
  { path: '/tags', component: TagList },
  { path: '/tags/:tags', component: TagPage, props: true },
  { path: '/add', component: AddRecipe },
  { path: '*', component: FourOhFour }
]

const router = new VueRouter({
  routes
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
